module.exports = __webpack_public_path__ + "static/media/花泽香菜教你日语五十音.de6433ee.flv";